module.exports = __webpack_public_path__ + "static/img/feature-bg1.440e6ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/feature-bg1.png
// module id = mhk0
// module chunks = 36